import { css } from 'styled-system/css';

export const actionStyle = {
	action: css({
		display: 'flex',
		gap: { base: '6px', lg: '12px' },
		_lgBelow: {
			flexDir: 'column',
		},
	}),
	actionItem: css({
		flex: 1,
		display: 'flex',
		gap: { base: '6px', lg: '12px' },
	}),
	actionInfo: css({
		flex: 1,
		display: 'flex',
		flexDir: 'column',
		justifyContent: 'flex-end',
		alignItems: 'flex-end',
		py: { base: '6px', lg: '12px' },
		gap: { base: '6px', lg: '12px' },
	}),
	qrcode: css({

	}),
	title: css({
		fontSize: {
			base: '16px',
			md: '20px',
			lg: '24px',
			xl: '28px',
		},
		color: 'jupiter.grey.60',
		textAlign: 'right',
	}),
	button: css(),
	actionImage: css({
		display: 'flex',
		flex: 1,
		pos: 'relative',
		alignItems: 'flex-end',
		'& img': {
			pos: 'absolute',
			bottom: 0,
			left: 0,
		}
	}),
	android: css({
		pos: 'absolute',
		left: '23px',
		bottom: 0,
	}),
}